import { render, staticRenderFns } from "./documentsList.vue?vue&type=template&id=65f3ad0e&scoped=true"
import script from "./documentsList.vue?vue&type=script&lang=js"
export * from "./documentsList.vue?vue&type=script&lang=js"
import style0 from "./documentsList.vue?vue&type=style&index=0&id=65f3ad0e&prod&lang=css"
import style1 from "./documentsList.vue?vue&type=style&index=1&id=65f3ad0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f3ad0e",
  null
  
)

export default component.exports